// Frontend logging service that sends logs to backend for persistent storage
import { apiFetch } from './api';

class Logger {
  constructor() {
    this.logQueue = [];
    this.isProcessing = false;
  }

  // Log levels
  static LEVELS = {
    DEBUG: 'DEBUG',
    INFO: 'INFO',
    WARN: 'WARN',
    ERROR: 'ERROR'
  };

  // Send log to backend
  async sendLogToBackend(level, message) {
    try {
      const timestamp = new Date().toISOString();
      const logData = {
        level,
        message: `${timestamp} - ${message}`,
        timestamp
      };

      // Also log to console for immediate debugging
      console.log(`[${level}] ${message}`);

      // Send to backend
      // await apiFetch('/api/frontend-log/', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   credentials: 'include',
      //   body: JSON.stringify(logData),
      //});
    } catch (error) {
      // If backend logging fails, at least keep console logging
      console.error('Failed to send log to backend:', error);
      console.log(`[${level}] ${message}`);
    }
  }

  // Queue logs to avoid overwhelming the backend
  queueLog(level, message) {
    this.logQueue.push({ level, message });
    this.processQueue();
  }

  async processQueue() {
    if (this.isProcessing || this.logQueue.length === 0) {
      return;
    }

    this.isProcessing = true;
    
    while (this.logQueue.length > 0) {
      const { level, message } = this.logQueue.shift();
      await this.sendLogToBackend(level, message);
      // Small delay to avoid overwhelming the server
      await new Promise(resolve => setTimeout(resolve, 50));
    }

    this.isProcessing = false;
  }

  // Logging methods
  debug(message) {
    this.queueLog(Logger.LEVELS.DEBUG, message);
  }

  info(message) {
    this.queueLog(Logger.LEVELS.INFO, message);
  }

  warn(message) {
    this.queueLog(Logger.LEVELS.WARN, message);
  }

  error(message) {
    this.queueLog(Logger.LEVELS.ERROR, message);
  }

  // Special method for logging objects/data
  logData(level, description, data) {
    const message = `${description}: ${JSON.stringify(data, null, 2)}`;
    this.queueLog(level, message);
  }
}

// Create singleton instance
const logger = new Logger();

export default logger;
